/**
 * What the Android back gesture should do, given where you are.
 *
 * Pure so it can be tested without a device: the whole bug was that nothing
 * handled back at all, so the system closed the app from inside a note.
 */
export type Pane = 'folders' | 'list' | 'editor'

export interface BackContext {
  /** Which pane is showing, on a screen narrow enough to show only one. */
  pane: Pane
  /** True when the layout shows all three panes at once. */
  wide: boolean
  /** Anything modal that should absorb back before navigation does. */
  overlayOpen?: boolean
}

export type BackAction =
  | { kind: 'close-overlay' }
  | { kind: 'go'; pane: Pane }
  | { kind: 'exit' }

export function backAction(ctx: BackContext): BackAction {
  // A dialog or sheet takes precedence: back should dismiss what is on top.
  if (ctx.overlayOpen) return { kind: 'close-overlay' }

  // On a wide layout nothing is stacked, so back leaves the app as usual.
  if (ctx.wide) return { kind: 'exit' }

  if (ctx.pane === 'editor') return { kind: 'go', pane: 'list' }
  if (ctx.pane === 'list') return { kind: 'go', pane: 'folders' }
  // Already at the root of the stack.
  return { kind: 'exit' }
}
